import React from 'react'
import { Outlet } from 'react-router-dom'

import { useLayout } from '@app/routing/LayoutContext'

import { useAccountReadContext } from '@context/AccountContextContext'

import { isDocumentManagementNotificationNeeded } from '@utils/AccountAccess/accountDocumentStatuses'

import { DocumentManagementNotification } from './DocumentManagement/DocumentManagementPage'

export const Profile: React.FC = () => {
  const { account } = useAccountReadContext()
  const { hasNotices } = useLayout()

  return (
    <>
      {hasNotices && isDocumentManagementNotificationNeeded(account) && (
        <DocumentManagementNotification />
      )}
      <Outlet />
    </>
  )
}
